import {InputFormatType} from "../../../../formability/form_builder/models/inputFormatType";
import {ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
import {FormElementType} from "../../../enums/formElementType";
import {SalesforceApiDataType} from "~/enums/salesforceApiDataType";

let ift = InputFormatType;
let omt = ObjectModelPropertyRootType;
let sft = SalesforceApiDataType;

export const BaseInputFormElementObjectModelPropertyBlocklist: Array<any> = [
  omt.PickList,
  omt.DateTime
]

export const InputFormElementIncompatibleTypes = {
  [InputFormatType.None]: {
    ObjectModelProperties: BaseInputFormElementObjectModelPropertyBlocklist.concat([
      omt.Number,
      {[omt.Text]: [
          ift.Numeric,
          ift.Alphanumeric,
          ift.Email,
          ift.Phone,
          ift.Zip,
          ift.Url,
          ift.Currency,
          ift.Pattern,
          ift.SocialSecurity,
        ]},
    ]),
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.address
    ]
  },
  [InputFormatType.Numeric]: {
    ObjectModelProperties: BaseInputFormElementObjectModelPropertyBlocklist.concat([
      {[omt.Text]: [
          ift.Phone,
          ift.Email,
          ift.Url,
          ift.Pattern,
          ift.SocialSecurity
        ]},
    ]),
    Salesforce: [
      sft.comboBox,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.textarea,
      sft.address
    ]
  },
  [InputFormatType.Alphanumeric]: {
    ObjectModelProperties: BaseInputFormElementObjectModelPropertyBlocklist.concat([
      {[omt.Text]: [
          ift.Numeric
        ]},
      {[omt.Number]: [
          ift.Numeric
        ]},
      omt.Number,
    ]),
    Salesforce: [
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.address
    ]
  },
  [InputFormatType.Email]: {
    ObjectModelProperties: BaseInputFormElementObjectModelPropertyBlocklist.concat([
      {[omt.Text]: [
          ift.Numeric,
          ift.SocialSecurity,
          ift.Pattern,
          ift.Zip,
          ift.Phone
        ]},
      omt.Number
    ]),
    Salesforce: [
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.address
    ]
  },
  [InputFormatType.Phone]: {
    ObjectModelProperties: BaseInputFormElementObjectModelPropertyBlocklist.concat([
      omt.Number,
    ]),
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.address
    ]
  },
  [InputFormatType.Zip]: {
    ObjectModelProperties: BaseInputFormElementObjectModelPropertyBlocklist.concat([
      {[omt.Text]: [
          ift.Email,
          ift.SocialSecurity,
          ift.Pattern,
          ift.Phone
        ]},
      {[omt.Number]: [
          ift.Currency
        ]},
      omt.Number,
    ]),
    Salesforce: []
  },
  [InputFormatType.Url]: {
    ObjectModelProperties: BaseInputFormElementObjectModelPropertyBlocklist.concat([
      {[omt.Text]: [
          ift.Numeric,
          ift.Phone,
          ift.Pattern,
          ift.Email,
          ift.SocialSecurity,
          ift.Alphanumeric
        ]},
      omt.PickList,
      omt.Number,
    ]),
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.picklist,
      sft.reference,
      sft.phone,
      sft.address
    ]
  },
  [InputFormatType.Currency]: {
    ObjectModelProperties: BaseInputFormElementObjectModelPropertyBlocklist,
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.percent,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.textarea,
      sft.address
    ]
  },
  [InputFormatType.Pattern]: {
    ObjectModelProperties: BaseInputFormElementObjectModelPropertyBlocklist.concat([
      {[omt.Text]: [
          ift.Alphanumeric,
          ift.Phone,
          ift.Pattern,
          ift.SocialSecurity,
          ift.Url,
          ift.Email
        ]},
      omt.Number,
    ]),
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.textarea,
      sft.address
    ]
  },
  [InputFormatType.SocialSecurity]: {
    ObjectModelProperties: BaseInputFormElementObjectModelPropertyBlocklist.concat([
      {[omt.Text]: [
          ift.Email,
          ift.Url,
          ift.Phone,
          ift.Pattern,
        ]},
      {[omt.Number]: [
          ift.Currency
        ]},
      omt.Number,
    ]),
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.textarea,
      sft.address
    ]
  },
}

export const BaseFormElementIncompatibleTypes = {
  [FormElementType.textArea]: {
    ObjectModelProperties: [
      omt.Text,
      omt.PickList,
      omt.Number,
      omt.DateTime
    ],
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone,
      sft.address
    ]
  },
  [FormElementType.dropdown]: {
    ObjectModelProperties: [
      omt.Text,
      omt.LongText,
      omt.Number,
      omt.DateTime
    ],
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.reference,
      sft.url,
      sft.phone,
      sft.address,
      sft.textarea
    ]
  },
  [FormElementType.checkboxGroup]: {
    ObjectModelProperties: [
      omt.Text,
      omt.LongText,
      omt.Number,
      omt.DateTime
    ],
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.reference,
      sft.url,
      sft.phone,
      sft.address,
      sft.textarea,
      sft.picklist
    ]
  },
  [FormElementType.radioButtonGroup]: {
    ObjectModelProperties: [
      omt.Text,
      omt.LongText,
      omt.Number,
      omt.DateTime
    ],
    Salesforce: [
      sft.calculated,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.encryptedstring,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.reference,
      sft.url,
      sft.phone,
      sft.address,
      sft.textarea,
      sft.picklist
    ]
  },
  [FormElementType.dateTimePicker]: {
    ObjectModelProperties: [
      omt.Text,
      omt.LongText,
      omt.Number,
      omt.PickList
    ],
    Salesforce: [
      sft.address,
      sft.comboBox,
      sft.currency,
      sft.dataCategoryGroupReference,
      sft.email,
      sft.id,
      sft.junctionIdList,
      sft.location,
      sft.masterrecord,
      sft.multipicklist,
      sft.picklist,
      sft.reference,
      sft.url,
      sft.phone
    ]
  },
  [FormElementType.uploadFiles]: {
    ObjectModelProperties: [
      omt.Text,
      omt.LongText,
      omt.Number,
      omt.DateTime
    ],
    Salesforce: []
  }
}
